import * as React from "react";
import DataGrid from "../../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import CustomField from "../../../model/customField/CustomField";
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";
import TextUtils from "../../../utils/TextUtils";
import Toast from "../../helper/Toast";

interface ComponentProps {
	/**
	 * Custom fields list.
	 */
	customFields: CustomField[];
	/**
	 * Row click callback
	 */
	onRowClick?: (customField: CustomField) => void;
	/**
	 * Missing data text
	 */
	noDataText?: string;
}

export default class CustomFieldsTable extends React.Component<ComponentProps> {
	public static defaultProps: Partial<ComponentProps> = {
		noDataText: "No results",
	};

	render() {
		return (
			<DataGrid hasHover hasPointer>
				<thead>
				<tr>
					<th>Id</th>
					<th>Label</th>
					<th>Type</th>
					<th className={'text-center'}>Disabled from workspace</th>
					<th className={'text-center'}>Disabled from UI</th>
					<th>Options</th>
				</tr>
				</thead>
				<tbody>
				{this.props.customFields.map((field) => (
					<tr key={field.id} onClick={() => this.props.onRowClick(field)}>
						<td>
							<span onClick={(e) => this.onIdClick(e, field.id)}>{field.id}</span>
						</td>
						<td>{field.label}</td>
						<td>{field.fieldType}</td>
						<td className={'text-center'}>
							<Checkbox checked={field.disabledInWorkspace} disabled={true}/>
						</td>
						<td className={'text-center'}>
							<Checkbox checked={field.disabledInUi} disabled={true}/>
						</td>
						<td>{field.options.map((option, index) => (
							<div key={index}>{option}</div>
						))}</td>
					</tr>
				))}
				{this.props.customFields.length === 0 &&
				<tr>
					<td colSpan={5} className={'text-center'}>{this.props.noDataText}</td>
				</tr>
				}
				</tbody>
			</DataGrid>
		);
	}

	onIdClick(e: React.MouseEvent<HTMLSpanElement>, fieldId: string) {
		e.stopPropagation();
		TextUtils.copyToClipboard(fieldId);
		Toast.success("Custom field id copied successfully", "Copy to clipboard");
	}
}
